import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import 'fonts/fonts';
import TagManager from 'react-gtm-module';
import { initializeDatadogRum } from 'utils/datadog';
import { createLaunchDarklyProvider } from 'utils/launchDarklyBootstrap';
import { IntlProvider } from 'react-intl';
import translations from 'locales';

const tagManagerArgs = {
  gtmId: `${process.env.REACT_APP_TAG_MANAGER_ID}`,
};

TagManager.initialize(tagManagerArgs);
(async () => {
  const LDProvider = await createLaunchDarklyProvider();

  const language = navigator.language.split(/[-_]/)[0];

  ReactDOM.render(
    <LDProvider>
      <IntlProvider
        locale={language}
        defaultLocale="en"
        messages={translations[language] || translations.en}
      >
        <App />
      </IntlProvider>
    </LDProvider>,
    document.getElementById('root'),
  );
})();

initializeDatadogRum();
